/**
 * Controls whether or not we perform an RSC request when the page updates in NextJS
 */
export const NEXT_JS_RSC_ON_PAGE_UPDATE_231122 = 'NEXT_JS_RSC_ON_PAGE_UPDATE_231122';
